import { useEffect } from "react";

const FreshchatWidget = () => {
    useEffect(() => {
  
      if (!document.getElementById("freshchat-js")) {
        const script = document.createElement("script");
        script.id = "freshchat-js";
        script.src = "//eu.fw-cdn.com/13045020/995290.js";
        script.setAttribute("chat", "true");
        script.async = true;
        document.body.appendChild(script);
  
        script.onerror = () => {
          console.error("Erreur lors du chargement de Freshchat !");
        };
      }
    }, []);
  
    return null;
  };

export default FreshchatWidget;
